<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid p-0">
    <form id="projectSelectorForm" name="projectSelectorForm">
      <div class="row">
        <div class="col px-0">
          <div class="select_container" style="float:left">
            <select required class="form-control" v-bind:id="'select_project' +  getId()" data-fouc>
              <option value="" style="">{{ $t('project') }}</option>
              <option v-for="project in projects" v-bind:value="project.ProjectId">
                {{ project.Name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  var projects = [];
  export default {
    name: "project-selector",
    props: {
      loadDataOnInit: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        projects: []
      };
    },
    methods: {
      clearFields() {
        $("#select_project" + this.getId()).val('');
        $("#select_project" + this.getId()).trigger('change');
      },
      selectProject(selected) {
        $("#select_project" + this.getId()).val(selected);
        $("#select_project" + this.getId()).trigger('change');
      },
      fetchReloadData() {
        this.loadProjects();
      },
      onFormSubmit() {
        if (!$('#projectSelectorForm').valid()) {
        }
      },
      onChange() {
        this.$emit('event-change-project', $("#select_project" + this.getId()).val());
      },
      getId() {
        return this._uid;
      },
      doChange() {
      },
      loadProjects() {
        try {
          this.projects = [];
          var thisContext = this;
          var url = '/api/Projects/v1';
          this.$http.get(url).then(response => {
            thisContext.projects = response.data;
            $('#' + 'select_project' + thisContext.getId()).select2();
            this.$emit('eventdata', thisContext.projects != undefined && thisContext.projects != null ? thisContext.projects.length : 0);
          });
        }
        catch (err) {
          alert('some error:' + err)
        }
      }
    },
    watch: {

    },
    mounted() {
      if (this.loadDataOnInit == true) {
        this.loadProjects();
      }
      $("#select_project" + this.getId()).change(this.onChange);
      _componentValidation('#projectSelectorForm');
    }
  };
</script>

<style scoped>
  .select_container {
    width: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/components/project/project-selector.vue